// Validazione IBAN: formato + cifre di controllo (Mod-97, ISO 13616 / ISO 7064).

export function normalizeIban(iban) {
  return (iban || "").replace(/\s+/g, "").toUpperCase();
}

export function isValidIban(iban) {
  const v = normalizeIban(iban);
  // Codice paese (2 lettere) + 2 cifre di controllo + BBAN (11-30 alfanumerici) => lunghezza 15-34.
  if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/.test(v)) return false;
  // Sposta i primi 4 caratteri in coda e converte le lettere in numeri (A=10 ... Z=35).
  const rearranged = v.slice(4) + v.slice(0, 4);
  let expanded = "";
  for (const ch of rearranged) {
    expanded += (ch >= "0" && ch <= "9") ? ch : (ch.charCodeAt(0) - 55).toString();
  }
  // Mod 97 calcolato a blocchi per evitare overflow su numeri molto grandi.
  let remainder = 0;
  for (let i = 0; i < expanded.length; i++) {
    remainder = (remainder * 10 + (expanded.charCodeAt(i) - 48)) % 97;
  }
  return remainder === 1;
}
